/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cost: NonNullable<unknown>, balance: NonNullable<unknown> }} Aiflowcostpill3Inputs */

const en_aiflowcostpill3 = /** @type {(inputs: Aiflowcostpill3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cost ${i?.cost} credits · Balance ${i?.balance}`)
};

const de_aiflowcostpill3 = /** @type {(inputs: Aiflowcostpill3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kosten ${i?.cost} Credits · Guthaben ${i?.balance}`)
};

/**
* | output |
* | --- |
* | "Cost {cost} credits · Balance {balance}" |
*
* @param {Aiflowcostpill3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowcostpill3 = /** @type {((inputs: Aiflowcostpill3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowcostpill3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowcostpill3(inputs)
	return de_aiflowcostpill3(inputs)
});
export { aiflowcostpill3 as "aiFlowCostPill" }